import React from 'react';
import { fetchClaimedOpsUsers } from '../../services/api/cashless-vision';

export default class ClaimedByFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
    };
  }

  componentDidMount() {
    fetchClaimedOpsUsers()
      .then((response) => {
        const users = response.data?.opsUsers || (Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : []));
        users.unshift({
          "opsUserId": -1,
          "opsUserName": "Unclaimed"
      });
        this.setState({
          users : users,
        });
      })
      .catch((err) => {
        console.error({ err }, 'Couldnt fetch OPS Users');
        throw err;
      });
  }

  onChange = (e) => {
    this.props.onChange(e.target.value);
  };

  render() {
    const { users } = this.state;
    console.log({ users }, 'State');
    return (
      <select
        style={{
          width: '100%',
          fontSize: '12px',
          borderRadius: '10px',
          height: '42px',
        }}
        onChange={this.onChange}
        value={this.props.value}
      >
        <option value="">All</option>
        {users &&
          users.map((u) => {
            return (
              <option key={u.opsUserId} value={u.opsUserId}>
                {u.opsUserName}
              </option>
            );
          })}
      </select>
    );
  }
}

